import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ClinicManagerService } from '../../networking/services/clinic-manager.service';
import { SharedDataService } from '../../helper/services/shared-data.service';

@Component({
  selector: 'app-reset-password',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressBarModule,
    RouterLink
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {
  resetForm!: FormGroup
  currentView: 'form' | 'success' | 'error' = 'form'
  errorMessage: string = ''
  isLoading = false
  hidePassword = true
  hideConfirm = true
  private token: string = ''

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private clinicManagerService: ClinicManagerService,
    private sharedDataService: SharedDataService
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? ''

    this.resetForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordsMatchValidator })
  }

  passwordsMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('newPassword')
    const confirm = control.get('confirmPassword')
    if (password && confirm && password.value !== confirm.value) {
      return { passwordsMismatch: true }
    }
    return null
  }

  async submitReset(): Promise<void> {
    if (this.resetForm.invalid) return

    this.isLoading = true

    try {
      await this.clinicManagerService.alterPasswordAfterReset(
        this.token,
        this.resetForm.value.newPassword
      )
      this.currentView = 'success'
    } catch (error: any) {
      this.sharedDataService.toggleProgressBarOff()

      if (error?.status === 401) {
        this.errorMessage = 'Der Link ist abgelaufen. Bitte fordere einen neuen an.'
      } else if (error?.status === 404) {
        this.errorMessage = 'Ungültiger Link.'
      } else {
        this.errorMessage = 'Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.'
      }
      this.currentView = 'error'
    } finally {
      this.isLoading = false
    }
  }
}
